export const SHARE_BASE = 'https://free.nowline.io/open';
export const EMBED_BUNDLE_URL = 'https://embed.nowline.io/0.4/nowline.min.js';
